import { CLICK_USER_PROFILE } from "../actions/types";

const initialState = {
    // isSearchLoading:false
    name: '',
    firstName:'',
    lastName:'',
    email:''
}


export default (state = initialState, action) => {
    switch (action.type) {
        case CLICK_USER_PROFILE :
            return {
                ...state,
            //  isSearchLoading:action.payload.isSearchLoading
            // name:action.payload.userSearch.,
            firstName:action.payload.userSearch.first_name,
            lastName:action.payload.userSearch.last_name,
            email:action.payload.userSearch.company_email
             
            }
            break;
        default:
            return state;
            break;
    }
 }